import { QueryClient } from "@tanstack/react-query";

// Cache client PARTAGÉ entre les onglets.
// - staleTime 60 s : aligné sur les TTL backend courts (live 30-60 s) — au-delà, refetch
//   automatique : jamais de donnée périmée réutilisée silencieusement.
// - Les clés incluent TOUJOURS le tenant (voir useApiQuery) : isolation stricte.
// - clearAllQueries() est appelé à chaque logout / début / fin d'impersonation :
//   aucun résultat du tenant précédent ne survit en mémoire.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export const clearAllQueries = () => queryClient.clear();
